function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// lib imports
import React, { useState, useRef, useMemo } from 'react';
import { Button, Box, Drop, Text } from 'grommet';
import { Add, Edit, Close, MoreVertical, Trash, CloudUpload, View } from 'grommet-icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// CORE imports
import Popconfirm from 'granite-admin/core/components/Popconfirm';
import MenuButton from 'granite-admin/core/components/MenuButton';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
import Loader from 'granite-admin/core/components/Loader';
const StyledBox = styled(Box)`
  &:focus {
    outline: none;
  }
`;
const renderItems = (showDrop, items, data) => {
  const itemList = items.map(item => {
    return /*#__PURE__*/React.createElement(MenuButton, {
      reverse: true,
      key: item.name,
      label: item.label,
      icon: item.icon,
      onClick: () => {
        item.onClick(data);
        showDrop(false);
      }
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, itemList);
};
export const ActionsCell = ({
  cell: {
    value: buttons
  },
  row,
  addHandler,
  actionIconColor,
  queryKey,
  newRows,
  columns,
  rowSaveLoader,
  className,
  ...rest
}) => {
  const actions = useMemo(() => {
    let list = [];
    let extra = {
      name: 'more',
      color: 'secondary',
      items: []
    };
    if (buttons?.length) {
      buttons.forEach((button, index) => {
        if (index < 3) list.push(button);else extra.items.push(button);
      });
    }
    if (extra.items.length) list.push(extra);
    return list;
  }, [buttons]);
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  const [drop, showDrop] = useState(false);
  const childRef = useRef();
  let buttonsJsx = [];
  if (rowSaveLoader?.[row?.original?._type]) {
    buttonsJsx.push( /*#__PURE__*/React.createElement(Box, {
      flex: true,
      align: "center",
      justify: "center",
      direction: "row"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "12px"
    }), /*#__PURE__*/React.createElement(Box, {
      pad: {
        left: 'small'
      }
    }, "Saving...")));
  }
  if (addHandler) {
    if (row?.original?._type) {
      if (!addHandler?.saveOn || !addHandler.hideWhenSaveOn) {
        buttonsJsx.push( /*#__PURE__*/React.createElement(Button, {
          disabled: rowSaveLoader?.[row?.original?._type],
          title: "save",
          icon: /*#__PURE__*/React.createElement(CloudUpload, {
            size: "small",
            color: actionIconColor
          }),
          onClick: e => {
            e.stopPropagation();
            grandEmitter.emit(`${queryKey}_SAVE_NEW_ROW`, {
              index: row?.index,
              _type: row?.original?._type
            });
          },
          tabIndex: columns.length + row?.index
        }));
      }
      if (row.original?.pk && actions.find(i => i.name === 'delete') || row?.original?._type && !row?.original?.pk) buttonsJsx.push( /*#__PURE__*/React.createElement(StyledBox, {
        onClick: e => e.stopPropagation(),
        focusIndicator: false
      }, /*#__PURE__*/React.createElement(Popconfirm, {
        align: "right",
        onConfirm: () => {
          grandEmitter.emit(`${queryKey}_DELETE_ROW`, {
            index: row?.index,
            _type: row?.original?._type
          });
        }
      }, /*#__PURE__*/React.createElement(Button, {
        icon: /*#__PURE__*/React.createElement(Trash, {
          size: "small",
          color: actionIconColor
        }),
        onClick: () => {},
        tabIndex: columns.length + row?.index
      }))));
      if (row.original?.pk) {
        buttonsJsx.push( /*#__PURE__*/React.createElement(Button, {
          icon: /*#__PURE__*/React.createElement(Close, {
            size: "small",
            color: actionIconColor
          }),
          onClick: e => {
            e.stopPropagation();
            grandEmitter.emit(`${queryKey}_CLEAR_NEW_ROW`, {
              index: row?.index,
              id: row?.original?.pk,
              _type: row?.original?._type
            });
          }
        }));
      }
    } else if (!addHandler.disableAdd) {
      if (!newRows[`add_${row?.original?.pk}`] && !row?.original?._type) buttonsJsx.push( /*#__PURE__*/React.createElement(Button, {
        icon: /*#__PURE__*/React.createElement(Add, {
          size: "small",
          color: actionIconColor
        }),
        onClick: e => {
          e.stopPropagation();
          grandEmitter.emit(`${queryKey}_ADD_NEW_ROW`, {
            index: row?.index,
            id: row?.original?.pk
          });
        }
      }));
    }
  }
  if (actions.length) {
    actions.forEach((btn, i) => {
      switch (btn.name) {
        case 'edit':
          if (!(row.original?.pk && row?.original?._type)) buttonsJsx.push( /*#__PURE__*/React.createElement(Button, _extends({
            key: i,
            icon: /*#__PURE__*/React.createElement(Edit, {
              size: "small",
              color: btn.color
            })
          }, btn)));
          break;
        case 'delete':
          buttonsJsx.push( /*#__PURE__*/React.createElement(StyledBox, {
            key: i,
            onClick: e => e.stopPropagation(),
            focusIndicator: false
          }, btn?.disabled ? /*#__PURE__*/React.createElement(Button, _extends({
            icon: /*#__PURE__*/React.createElement(Trash, {
              size: "small",
              color: btn.color
            })
          }, btn, {
            onClick: () => {}
          })) : /*#__PURE__*/React.createElement(Popconfirm, {
            align: "right",
            onConfirm: btn.onClick
          }, /*#__PURE__*/React.createElement(Button, _extends({
            icon: /*#__PURE__*/React.createElement(Trash, {
              size: "small",
              color: btn.color
            })
          }, btn, {
            onClick: () => {}
          })))));
          break;
        case 'view':
          buttonsJsx.push( /*#__PURE__*/React.createElement(Button, _extends({
            key: i,
            icon: /*#__PURE__*/React.createElement(View, {
              size: "small",
              color: btn.color
            })
          }, btn)));
          break;
        case 'more':
          buttonsJsx.push( /*#__PURE__*/React.createElement(Box, {
            onClick: e => e.stopPropagation(),
            key: i
          }, /*#__PURE__*/React.createElement(Button, {
            key: i,
            icon: /*#__PURE__*/React.createElement(MoreVertical, {
              size: "small",
              color: btn.color
            }),
            onClick: () => {
              if (drop) {
                showDrop(false);
                childRef.current.blur();
              } else showDrop(true);
            },
            ref: childRef
          }), childRef.current && drop && /*#__PURE__*/React.createElement(Drop, {
            target: childRef.current,
            elevation: "small",
            align: {
              top: 'bottom',
              right: 'right'
            },
            onClickOutside: e => !childRef.current.contains(e.target) && showDrop(false)
          }, renderItems(showDrop, btn.items, row?.original))));
          break;
        default:
          buttonsJsx.push( /*#__PURE__*/React.createElement(Button, _extends({
            key: i
          }, btn, {
            onClick: e => {
              e.stopPropagation();
              btn.onClick(row?.original);
            }
          })));
      }
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    height: {
      min: '26px'
    },
    className: className
  }, buttonsJsx), row?.original?.errors && /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, row?.original?.errors?.title));
};
ActionsCell.propTypes = {
  data: PropTypes.array,
  row: PropTypes.object,
  addHandler: PropTypes.any,
  actionIconColor: PropTypes.string,
  queryKey: PropTypes.string,
  newRows: PropTypes.any,
  tabIndex: PropTypes.array,
  columns: PropTypes.array,
  rowSaveLoader: PropTypes.object
};

// export default ActionsCell;